import { __assign } from "tslib";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import getContext from 'recompose/getContext';
import Image from '../components/Image';
import { getHeaderProps } from '../selectors/fixedArea';
import onlyIf from '../hocs/onlyIf';
import { isInHandoffMode } from '../selectors';
function mapStateToProps(state, _a) {
    var isCurrentScreen = _a.isCurrentScreen;
    return __assign(__assign({}, getHeaderProps(state, isCurrentScreen)), { hide: isInHandoffMode(state) });
}
var shouldRender = function (_a) {
    var header = _a.header, hide = _a.hide;
    return !hide && !!header;
};
export default compose(getContext({ isCurrentScreen: PropTypes.bool.isRequired }), connect(mapStateToProps), onlyIf(shouldRender))(Image);
